import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { OptionsInitialState } from './optionsState'

export const optionsSlice = createSlice({
  name: 'options',
  initialState: OptionsInitialState,
  reducers: {
    setButtonScrollMode: (
      state,
      { payload: { buttonMode } }: PayloadAction<{ buttonMode: boolean }>,
    ) => {
      state.buttonScrollMode = buttonMode
    },
    setAiAssistantMode: (
      state,
      {
        payload: { aiAssistantMode },
      }: PayloadAction<{ aiAssistantMode: boolean }>,
    ) => {
      state.aiAssistantMode = aiAssistantMode
    },
    setAiAssistantPersent: (
      state,
      { payload: { value } }: PayloadAction<{ value: string }>,
    ) => {
      state.aiAssistantPercent = Number(value)
    },
    setKeyboardMode: (
      state,
      { payload: { keyboardMode } }: PayloadAction<{ keyboardMode: boolean }>,
    ) => {
      state.keyboardMode = keyboardMode
    },
  },
})

export const {
  setButtonScrollMode,
  setKeyboardMode,
  setAiAssistantMode,
  setAiAssistantPersent,
} = optionsSlice.actions
export const { reducer: OptionsReducer } = optionsSlice
